module.exports = __webpack_public_path__ + "img/selfie.df386d85.png";